import { defineComponent } from 'vue';
import * as common from 'tour-component';
export * from 'tour-component';
import { indexTemplateHtml } from './variables';
/**
 * @public
 */
export var Tour = defineComponent({
    render: indexTemplateHtml,
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data: function () {
        return {
            index: 0,
        };
    },
    computed: {
        step: function () {
            return (this.index < this.data.steps.length && this.index >= 0) ? this.data.steps[this.index] : null;
        },
        arrowClassName: function () {
            return this.step ? "tour-arrow tt-" + this.step.direction : 'tour-arrow';
        },
        position: function () {
            return common.getStepPosition(this.step);
        },
    },
    beforeMount: function () {
        this.index = this.data.index;
    },
    mounted: function () {
        this.highlight();
    },
    methods: {
        next: function () {
            this.index++;
            this.$emit('update', this.index);
            this.highlight();
            if (this.index >= this.data.steps.length) {
                this.close();
            }
        },
        close: function () {
            this.index = -1;
            this.$emit('update', this.index);
            this.highlight();
            if (this.data.localStorageKey) {
                localStorage.setItem(this.data.localStorageKey, '1');
            }
        },
        highlight: function () {
            common.unhighlight(this.data.steps);
            if (this.step) {
                common.highlight(this.step);
                if (typeof this.step.scrollTop === 'number') {
                    window.scrollTo(0, this.step.scrollTop);
                }
            }
        },
    }
});
